/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import { get } from 'lodash/fp';
import { AutoSizer, Grid, MultiGrid } from 'react-virtualized';
import Tappable from '../../../components/commons/Tappable';
import SeasonLogCell from './SeasonLogCell';
import SeasonLogHeading from './SeasonLogHeading';
import NoHistory from './NoHistory';

type Props = {
  fixedColumnCount?: number,
  headerRowCount?: number,
  season: *,
  rowHeight?: number
};

type State = {
  expandedIndex: ?number
};

const Wrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.white,
  fontSize: theme.fontSize.tiny,
  fontWeight: '300',
  flexGrow: 1,
  overflow: 'auto',
  width: '100%',
  [theme.mediaQuery.tabletLandscapeAndUp]: {
    height: 270
  }
}));

Grid.defaultProps.overscanColumnCount = 100; // HACK

class SeasonLog extends React.Component<Props, State> {
  props: Props;

  state: State = {
    expandedIndex: null
  };

  static defaultProps = {
    fixedColumnCount: 2,
    headerRowCount: 1,
    rowHeight: 32
  };

  componentDidUpdate(prevProps, prevState) {
    const { expandedIndex } = this.state;

    if (prevState.expandedIndex !== expandedIndex) {
      // [MC] bit of a hack I think, can't work out how else to update the expanded rows though...
      // react-virtualized pure components can be hard to break
      if (
        this.multiGrid.current &&
        typeof this.multiGrid.current.recomputeGridSize === 'function'
      ) {
        try {
          this.multiGrid.current.recomputeGridSize();
        } catch (err) {
          // do nothing
        }
      }
    }
  }

  multiGrid = React.createRef();

  onHeaderClick(index) {
    this.setState(state => ({ expandedIndex: state.expandedIndex === index ? null : index }));
  }

  render() {
    const { fixedColumnCount, headerRowCount, rowHeight, season } = this.props;
    const { expandedIndex } = this.state;

    if (!season.logs || season.logs.length === 0) {
      return <NoHistory name={season.playerName} />;
    }

    const categories = Object.keys(season.logs[0].stats).map(field =>
      season.categories.find(c => c.id === field)
    );
    const categoriesCount = categories.length;
    const rowCount = headerRowCount + season.logs.length;

    return (
      <Wrapper>
        <AutoSizer>
          {({ height, width }) => (
            <MultiGrid
              ref={this.multiGrid}
              cellRenderer={({ key, rowIndex, columnIndex, ...cellProps }) =>
                rowIndex === 0 ? (
                  <Tappable
                    component={SeasonLogHeading}
                    key={key}
                    onTap={() => {
                      this.onHeaderClick(columnIndex);
                    }}
                    expanded={expandedIndex === columnIndex}
                    categories={categories}
                    columnIndex={columnIndex}
                    {...cellProps}
                  />
                ) : (
                  <SeasonLogCell
                    key={key}
                    data={season.logs[rowIndex - 1]}
                    categories={categories}
                    columnIndex={columnIndex}
                    {...cellProps}
                  />
                )
              }
              columnCount={categoriesCount}
              columnWidth={({ index }) => {
                if (get(`[${index}].id`, categories) === 'event') {
                  return 300;
                }
                return expandedIndex === index ? 100 : 55;
              }}
              fixedColumnCount={fixedColumnCount}
              fixedRowCount={headerRowCount}
              height={height}
              rowCount={rowCount}
              rowHeight={rowHeight}
              width={width}
            />
          )}
        </AutoSizer>
      </Wrapper>
    );
  }
}

export default SeasonLog;
